import React from 'react';
import './ComingSoon.css';

function ComingSoon() {
    return (
        <div className='coming-soon'>
            <div className="coming-soon-container">
                <h2>¡Próximamente!</h2>
                <p>Estamos trabajando en algo increíble. Vuelve pronto para descubrir nuestras novedades.</p>
            </div>
        </div>
    );
}

export default ComingSoon;
